/* eslint-disable no-negated-condition */
import React from 'react';
import { Field, Form } from 'formik';
import FormikInputField from 'components/Fields/FormikInputField';
import LoadingButton from 'components/common/LoadingButton';
import { FREEZE_STATUS } from 'pages/ApplicationUI/constant';

const freezeReasonSuggestions = [
  'Market is temporarily paused. Try again later.',
  'Marketplace will resume shortly.',
  'Trading is paused. Please check back later.',
];

const MarketFreezeDetailForm = (props) => {
  const {
    handleSubmit,
    isSubmitting,
    isValid,
    dirty,
    freezeStatus,
    setFieldValue,
    setFieldTouched,
  } = props;

  const handleSuggestionClick = (message) => {
    setFieldValue('freezeReason', message, true);
    setFieldTouched('freezeReason', true, false);
  };

  return (
    <Form onSubmit={handleSubmit}>
      {freezeStatus !== true ? (
        <>
          <Field
            id="freezeReason"
            name="freezeReason"
            type="textarea"
            label="Freeze Reason"
            className="border-field freeze-field"
            component={FormikInputField}
          />
          <div className="mt-3">
            <div className="f-12 fw-semibold text-muted mb-2">
              Quick Suggestions
            </div>
            <div className="d-flex flex-wrap gap-2">
              {freezeReasonSuggestions.map((message) => (
                <button
                  key={message}
                  type="button"
                  className="btn btn-light border text-start f-12"
                  style={{ whiteSpace: 'normal' }}
                  onClick={() => handleSuggestionClick(message)}
                >
                  {message}
                </button>
              ))}
            </div>
          </div>
          <div className="form-btn d-flex justify-content-end mt-4">
            <LoadingButton
              className="mw-100 loading-button"
              loading={isSubmitting}
              disabled={!isValid || !dirty || isSubmitting}
              color="warning"
              size="sm"
              type="submit"
            >
              {freezeStatus ? FREEZE_STATUS.UNFREEZE : FREEZE_STATUS.FREEZE}
            </LoadingButton>
          </div>
        </>
      ) : (
        <div className="form-btn d-flex justify-content-end mt-4">
          <LoadingButton
            className="mw-100 loading-button"
            loading={isSubmitting}
            disabled={isSubmitting}
            color="warning"
            size="sm"
            type="submit"
          >
            {freezeStatus ? FREEZE_STATUS.UNFREEZE : FREEZE_STATUS.FREEZE}
          </LoadingButton>
        </div>
      )}
    </Form>
  );
};

export default MarketFreezeDetailForm;
